import Vue from 'vue';
export default Vue.component('ed-list', {
  name: 'ed-list',
  props: {
    dense: {
      type: Boolean,
      default: false
    },
  },
});